/**
 * Configurazione centralizzata per l'applicazione
 *
 * In produzione, le variabili vengono iniettate dal docker-entrypoint.sh
 * tramite window.ENV nel file runtime-config.js
 */

// Fallback per sviluppo locale
const defaultApiUrl = "https://apinvrsion.invrsion.com/wp-json/tw/v1";

// Usa variabile d'ambiente runtime se disponibile, altrimenti fallback
export const BaseUrl = window.ENV?.REACT_APP_API_URL ||
                       process.env.REACT_APP_API_URL ||
                       defaultApiUrl;

export const config = {
  apiUrl: BaseUrl,
  environment: window.ENV?.REACT_APP_ENVIRONMENT ||
               process.env.REACT_APP_ENVIRONMENT ||
               'development'
};

export default config;
